import { render } from "./addIncome.vue?vue&type=template&id=d3b5eaf8&scoped=true"
import script from "./addIncome.vue?vue&type=script&lang=js"
export * from "./addIncome.vue?vue&type=script&lang=js"

import "./addIncome.vue?vue&type=style&index=0&id=d3b5eaf8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b5eaf8"]])

export default __exports__